<template>
  <div class="img_box" :height="fullHeight" :width="fullWidth" style="position: relative">
<!--    <Authorization :show="show" :title="title" @hideModal="hideModal" @submit="submit">-->
<!--      <p>这里放弹窗的内容</p>-->
<!--    </Authorization>-->
    <img src="../assets/login/login-bkg.png" :width="fullWidth" :height="fullHeight" style="position: absolute"/>
    <img src="../assets/login/DChain.png" style="position: absolute; margin-left: 3%;margin-top: 3% ;"/>
    <div style="position: absolute; margin-left: 65%; margin-top: 2.5%;margin-bottom: 1.5%; width: 35%;">
      <div style="background-color: #ffffff; width: 95%">
        <div style="height: 1px"/>
        <div style="margin-top: 7%">
          <b style="color: #13498b; font-size: 40px; font-family: -apple-system;
         letter-spacing: 3px; margin-left: 8%; margin-top:10%;">Welcome!</b>
        </div>
        <div style="margin-top: 15%">
          <b
            style="color: black ;font-size: 20px; letter-spacing: 3px; font-family: -apple-system; margin-bottom: 50%; margin-left: 8%; margin-top:10%; ">
            Please select the account to login:
          </b>
        </div>
        <div style="margin-left: 6%; margin-top: 5%; margin-bottom: 110%" class="login">
          <a-dropdown style="width: 20%;">
            <a-menu slot="overlay" @click="handleLazadaClick">
              <a-menu-item key="1">
                <a :href="lzdUrl + 'LAZADA_SG'">
                <img src="../assets/country/Sg.png" style="margin-right: 5%; height: 25px"/> Singapore
                </a>
              </a-menu-item>
              <a-menu-item key="2">
                <a :href="lzdUrl + 'LAZADA_MY'">
                <img src="../assets/country/My.png" style="margin-right: 5%;height: 25px"/> Malaysia
                </a>
              </a-menu-item>
              <a-menu-item key="3">
                <a :href="lzdUrl + 'LAZADA_ID'">
                <img src="../assets/country/Id.png" style="margin-right: 5%;height: 25px"/> Indonesia
                </a>
              </a-menu-item>
              <a-menu-item key="4">
                <a :href="lzdUrl + 'LAZADA_PH'">
                <img src="../assets/country/Ph.png" style="margin-right: 5%;height: 25px"/>Philippines
                </a>
              </a-menu-item>
              <a-menu-item key="5">
                <a :href="lzdUrl + 'LAZADA_TH'">
                <img src="../assets/country/Th.png" style="margin-right: 5%;height: 25px"/> Thailand
                </a>
              </a-menu-item>
              <a-menu-item key="6">
                <a :href="lzdUrl + 'LAZADA_VN'">
                <img src="../assets/country/Vn.png" style="margin-right: 5%;height: 25px"/> Vietnam
                </a>
              </a-menu-item>
            </a-menu>
            <a-button style="margin-left: 8px;  font-size: medium"><img src="../assets/country/LZD2.png" style="width: 20%">
              Lazada
            </a-button>
          </a-dropdown>
          <a-button style="margin-left: 8px; color: coral; font-size: large;" class="login">
            <a :href="aeUrl">AliExpress</a>
          </a-button>
        </div>
        <div style="height: 1px"/>
      </div>
    </div>
  </div>
</template>
<script>
// import Authorization from '../components/Authorization'
export default {
  data () {
    return {
      fullWidth: document.documentElement.clientWidth,
      fullHeight: document.documentElement.clientHeight,
      lzdUrl: this.getLzdUrl(),
      aeUrl: this.getAeUrl(),
      title: '弹窗标题',
      show: true
    }
  },
  // components: {
  //   Authorization
  // },
  created () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize (event) {
      this.fullWidth = document.documentElement.clientWidth
      this.fullHeight = document.documentElement.clientHeight
    },
    getLzdUrl () {
      let uri = location.href
      if (uri.indexOf('pre') > -1) {
        return 'https://pre-allinone.ascp.alibaba.com/login/lzd/getCode?site='
      }
      return 'https://login-cb.ascp.alibaba.com/login/lzd/getCode?site='
    },
    getAeUrl () {
      let uri = location.href
      if (uri.indexOf('pre') > -1) {
        return 'https://pre-allinone.aliexpress.com/login/aeg/session'
      }
      return 'https://login.allinone.aliexpress.com/login/aeg/session'
    },
    hideModal () {
      // 取消弹窗回调
      this.show = false
    },

    submit () {
      // 确认弹窗回调
      this.show = false
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/Login.vue